import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";
import { useAuth } from "./auth";

const ChildCtx = createContext(null);
const SELECTED_KEY = "orbit_selected_child";

export function ChildProvider({ children }) {
  const { user } = useAuth();
  const [list, setList] = useState([]);
  const [selectedId, setSelectedId] = useState(localStorage.getItem(SELECTED_KEY) || null);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!user) {
      setList([]);
      return;
    }
    setLoading(true);
    try {
      const r = await api.get("/children");
      setList(r.data);
      if (r.data.length) {
        const stored = localStorage.getItem(SELECTED_KEY);
        const exists = stored && r.data.find((c) => c.id === stored);
        if (!exists) {
          setSelectedId(r.data[0].id);
          localStorage.setItem(SELECTED_KEY, r.data[0].id);
        } else {
          setSelectedId(stored);
        }
      } else {
        setSelectedId(null);
      }
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const selectChild = (id) => {
    setSelectedId(id);
    localStorage.setItem(SELECTED_KEY, id);
  };

  const selected = list.find((c) => c.id === selectedId) || null;

  const upsertSelected = (updated) => {
    setList((cur) => cur.map((c) => (c.id === updated.id ? updated : c)));
  };

  return (
    <ChildCtx.Provider
      value={{ list, selected, selectChild, refresh, loading, upsertSelected }}
    >
      {children}
    </ChildCtx.Provider>
  );
}

export function useChild() {
  return useContext(ChildCtx);
}
